import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faTwitter } from '@fortawesome/free-brands-svg-icons';


import constants from '../constants';
import SSUtils from '../util/SSUtils';
// import Bookmark from 'react-bookmark';

import "./Footer.css";
// import constants from '../constants';

class Footer extends React.Component {
  render() {
    return (
      <div>
        {SSUtils.getSupportUs()}
        {/* <div className="compFooter">
          <div className="socialMedias">
            <a href="https://twitter.com/SmartStake" className="fab fa-twitter fa-lg"/>
          </div>
          <span className="versionInfo">Version: {constants.APP_KEY} {global.appVersion}</span>
        </div> */}
        <div className="compFooter">
          <div className="socialMedias">
            <a href="https://twitter.com/SmartStake" target="_blank" title="twitter" className="mediaCustom"><FontAwesomeIcon icon={faTwitter} /></a>
            &nbsp;&nbsp;&nbsp;
            <a href="https://t.me/SmartStake" target="_blank" title="telegram" className="mediaCustom"><FontAwesomeIcon icon={faTelegram} /></a>
          </div>
          <span className="versionInfo">{constants.APP_KEY} {global.appVersion}</span>
        </div>
      </div>
    );
  }

}

export default Footer;
